import { css } from '@emotion/css';
import colors from '@/theme/colors';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { Translate, Drawer } from '@/components';
import { Flyer } from '@/graphql/types';

interface Props {
  flyer: Flyer;
  showOptions: boolean;
  setShowOptions: (show: boolean) => void;
  onShare: () => void;
  downloadPDF: (url: string) => void;
  openLink: (origin, url: string) => void;
  addToCalendar: () => void;
  contactClick: (origin: string, email: string) => void;
}

const styles = {
  drawerItem: css`
  color: ${colors.prussian};
`,
}

export const FlyerDetailsDrawer: React.FC<Props> = ({
  flyer,
  showOptions,
  setShowOptions,
  onShare,
  downloadPDF,
  openLink,
  addToCalendar,
  contactClick,
}) => {
  const options = [
    {
      name: 'Open in browser',
      action: () => {
        openLink(
          'open_in_browser',
          `https://app.peachjar.com/flyers/${flyer.flyerId}/districts/${flyer.districtId}`,
        );
      },
    },
    {
      name: 'Share',
      action: () => onShare(),
    },
    {
      name: 'Contact',
      action: () => {
        contactClick('option', flyer.email);
      },
    },
    {
      name: 'Report link',
      action: () => {
        console.log('report link');
      },
    },
  ];
  return (
    <Drawer
      title="Options"
      isOpen={showOptions}
      onToggle={setShowOptions}
      data-testid="flyerDetailsOptions"
    >
      {options.map(option => (
        <ListItem
          disablePadding
          key={option.name}
          onClick={option.action}
          data-testid="flyerDetailsOption"
        >
          <ListItemButton>
            <ListItemText
              primary={<Translate>{option.name}</Translate>}
              className={styles.drawerItem}
            />
          </ListItemButton>
        </ListItem>
      ))}
    </Drawer>
  );
};

